<template>
</template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        width: {
          name: 'width',
          defaultValue: '100',
          min: '30',
          max: '300',
          labelDesc: 'width',
          callback: function() {
            console.log(this);
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.width = this.value + 'px';
            vm.element.internal_config.height = this.value + 'px';
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          }
        },
        theme: {
          name: 'type',
          defaultValue: '',
          labelDesc: 'theme',
          options: [
            {name: '01', value: '01', selected: 'selected', disabled: false},
            {name: '02', value: '02', selected: false, disabled: false},
            {name: '03', value: '03', selected: false, disabled: false},
            {name: '04', value: '04', selected: false, disabled: false}
          ],
          callback: function() {
            vm.resources.theme.defaultValue = this.value;
            vm.element.internal_config.theme = this.value;
          }
        },
      }
    };
  },
  methods: {
    setMinValuesData(resource, value) {
      this.resources[resource].min = parseInt(value);
    },
    setValuesData(data) {
      this.element = data;
      this.resources.width.defaultValue = data.internal_config.width;
      this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
      this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
      this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
      this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
      this.resources.theme.defaultValue = data.internal_config.theme;

      this.resources.zIndex.defaultValue = data.internal_config.zIndex;

    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/RSS/Resources.vue